// Copyright (c) 2026. LodgIQ Inc, All rights reserved
//
// Login-page promo BAND overlaid on the skyline photo — advertises "Ask LodgIQ".
// Public-safe (no real data). No LodgIQ wordmark/tagline here (the left panel
// already carries the logo). Brand: #01A4EF blue, #B0E80E lime, #00415F steel,
// #90D6F0 light blue; Montserrat headline, Libre Baskerville italic kicker.

import React from "react";
import "./AskLodgiqPromo.scss";

const Sparkles = ({ width = 18, height = 16 }) => (
  <svg viewBox="6 6 21 19" width={width} height={height} aria-hidden="true">
    <path d="M14.5 8.5 C15.3 13.2 16.9 14.8 21.6 15.6 C16.9 16.4 15.3 18 14.5 22.7 C13.7 18 12.1 16.4 7.4 15.6 C12.1 14.8 13.7 13.2 14.5 8.5 Z" fill="#01A4EF" />
    <path d="M22.3 8 C22.7 10.3 23.5 11.1 25.8 11.5 C23.5 11.9 22.7 12.7 22.3 15 C21.9 12.7 21.1 11.9 18.8 11.5 C21.1 11.1 21.9 10.3 22.3 8 Z" fill="#B0E80E" />
  </svg>
);

export default function AskLodgiqPromo() {
  return (
    <div className="lq-promo" aria-label="Introducing Ask LodgIQ">
      <div className="lq-promo__band">
        <div className="lq-promo__tag">
          <Sparkles />
          <span className="lq-promo__product">ASK&nbsp;LODGIQ</span>
          <span className="lq-promo__beta">BETA</span>
        </div>
        <h1 className="lq-promo__head">
          Your data just learned to <span className="lq-promo__accent">talk</span>.
        </h1>
        <div className="lq-promo__kicker">ask in plain English — it answers in your numbers</div>
        <div className="lq-promo__feature">
          Grounded in your live OTB, forecast &amp; market data — with a link to the chart behind every number.
        </div>
        <div className="lq-promo__access">
          Rolling out in Beta — contact{" "}
          <a href="mailto:success@lodgiq.com">success@lodgiq.com</a> for access.
        </div>
      </div>
    </div>
  );
}
